export const GET_MUNDIAL_BRACKETS = 'GET_MUNDIAL_BRACKETS';
